import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import { Link } from "react-router-dom";
import jardaction from '../../context/action/report/jardaction.js'
import Jardtable from "./jardtable";
import expense from "../../context/action/report/expense";
import Expensetable from "./expensetable";
import sellreportaction from "../../context/action/report/sellreportaction";
import Selltable from "./selltable";
import companyaction from "../../context/action/report/companyaction";
import Companytable from "./companytable";
import brokeaction from "../../context/action/report/brokeaction";
import Broketable from "./broketable";
import summaryaction from "../../context/action/report/summaryaction";
import Summarytable from "./summarytable";
import Itemselltable from "./itemselltable";
import itemsellaction from "../../context/action/report/itemsellaction";
import '../../component/css/onprintcss.css';
import Selltableprint from "./selltableprint";
const Report = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  const [from, setfrom] = useState();
  const [to, setto] = useState();
  const [company_id, setcompany_id] = useState();
  const [casher_id, setcasher_id] = useState();
  const [category_id, setcategory_id] = useState();
  const [barcode, setbarcode] = useState();

  const [type, settype] = useState();
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  
  
  const printit=()=>{
    window.print();
  } 
  
  return (
    <div className="bg-slate-50 min-h-screen w-full">
      {/* Header - Top Right Position */}
      <div className="w-full pt-8 sm:pt-10 md:pt-12 px-6 sm:px-8 md:px-12 flex justify-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
          ڕاپۆرت
        </h1>
      </div>

      {/* Main Content with Padding */}
      <div className="w-full px-6 sm:px-8 md:px-12 py-8 sm:py-10 md:py-12">
        
        {/* Report Cards - First Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6">
          {/* Stock Card */}
          <Link
            to={"/report/stock"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                جەردی مەخزەن
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>

          {/* Sell Card */}
          <Link
            to={"/report/sell"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                فرۆش
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Report Cards - Second Row */}
        <div className="mt-4 md:mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6">
          {/* Customer Loan Card */}
          <Link
            to={"/report/customer_loan"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                قەرزی کڕیار
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>

          {/* Company Loan Card */}
          <Link
            to={"/report/company_loan"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                قەرزی کۆمپانیا
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Report Cards - Third Row */}
        <div className="mt-4 md:mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6">
          {/* Expense Card */}
          <Link
            to={"/report/expense"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                خەرجی
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>

          {/* Broke Card */}
          <Link
            to={"/report/broke"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                خەسار
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Summary Card - Full Width */}
        <div className="mt-4 md:mt-6 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4 md:gap-6">
          {/* <Link
            to={"/report/mizania"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                میزانییە
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link> */}
          <Link
            to={"/report/summary"}
            className="group cursor-pointer rounded-xl bg-white overflow-hidden transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-1"
            style={{
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRight: '4px solid #5446E5'
            }}
          >
            <div className="flex items-center justify-between p-4 sm:p-5 md:p-6 h-20 sm:h-24">
              <h5 className="text-base sm:text-lg md:text-lg font-bold text-gray-900 text-right pr-4">
                پوختە
              </h5>
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 group-hover:bg-purple-100 transition-colors">
                <span className="text-lg text-[#5446E5] font-semibold">←</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Bottom Padding */}
        <div className="pb-8 md:pb-12"></div>
      </div>
    </div>
  );
};

export default Report;
